import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { appRoutes } from './app.routes';
import { provideWebSdkInstance } from '@sxm-core/utility-code/angular/app-providers-web-sdk';
import { provideCountryConfig } from '@sxm-core/utility-code/angular/app-providers-country-config';
import { provideLocale } from '@sxm-core/utility-code/angular/app-providers-locale';
import { provideLocaleLegacy } from '@sxm-core/utility-code/angular/app-providers-locale-legacy';
import { provideSentry } from '@sxm-core/utility-code/angular/app-providers-sentry';
import { provideAdobeLaunch } from '@sxm-core/utility-code/angular/app-providers-adobe-launch';
import { provideChat } from '@sxm-core/utility-code/angular/app-providers-chat';
import { provideOneTrust } from '@sxm-core/utility-code/angular/app-providers-one-trust';
import { providerClickTrackAdobe } from '@sxm-core/utility-code/angular/app-providers-click-track-adobe';
import { Configs } from '@sxm-core/utility-code/typescript/browser-app-configs-types';
import { provideNgxStripe } from 'ngx-stripe';
import { IWebSDK } from '@sxm-de/dev-kits/web-sdk/core';
import { providerStripeConfig } from '@sxm-core/utility-code/angular/app-providers-stripe-config';

export const initAppConfig = (
    {
        appSettings,
        settings,
        thirdParty,
        logging,
        countryCode,
        locale,
    }: Configs,
    webSdk: IWebSDK,
): ApplicationConfig => {
    return {
        providers: [
            provideWebSdkInstance(webSdk),
            providerStripeConfig(thirdParty.stripe),
            provideAdobeLaunch({ adobeLaunchConfig: settings['adobeLaunch'] }),
            provideZoneChangeDetection({ eventCoalescing: true }),
            provideRouter(
                appRoutes,
                withComponentInputBinding(),
                withInMemoryScrolling({
                    scrollPositionRestoration: 'top',
                }),
            ),
            provideAnimationsAsync(),
            provideCountryConfig({ countryCode }),
            provideNgxStripe(),
            provideLocale({ locale }),
            provideLocaleLegacy({ locale }),
            provideSentry({ sentryConfig: logging['sentry'] }),
            provideChat({ chatProvider: thirdParty['chatProvider'] }),
            provideOneTrust({ oneTrustConfig: thirdParty['oneTrust'] }),
            providerClickTrackAdobe(),
        ],
    };
};
